module.exports = __webpack_public_path__ + "img/prize_c3.40508bef.png";